import React from "react";
import Button from "@rescui/button";
import {useAuth} from "../../hooks/useAuth";
import {useLocation} from "react-router-dom";
import {useTextStyles} from "@rescui/typography";
import {ProjectsLink} from "../../pages/Projects";

export function AuthStatus() {
  const {user, role, isLoading} = useAuth();
  const location = useLocation();
  const textCn = useTextStyles();
  const logout = () => {
    fetch("/auth/logout", {credentials: "include"}).then(() => {window.location.href = "/";});
  };
  return <div className="auth-status auth-status--grid">
    {isLoading && <span>Checking auth…</span>}
    {!isLoading && user && <>
      <span className="user-email">{user.email}</span><span className="user-role">({role})</span>
      {location.pathname !== "/projects" && <ProjectsLink className={textCn("rs-link")} />}
      <Button size="s" mode="clear" onClick={logout} className="logout-btn">Logout</Button>
    </>}
    {!isLoading && !user && <a href="/auth/login">Login</a>}
  </div>;
}
